import { render, staticRenderFns } from "./descListaLeechero.vue?vue&type=template&id=74cad6d3&scoped=true&"
import script from "./descListaLeechero.vue?vue&type=script&lang=js&"
export * from "./descListaLeechero.vue?vue&type=script&lang=js&"
import style0 from "./descListaLeechero.vue?vue&type=style&index=0&id=74cad6d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cad6d3",
  null
  
)

export default component.exports